import { debounce } from 'lodash';
import { useCallback } from 'react';

const useDebounce = (applyFilter: (val: string) => void, delay: number = 500) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const delayedApplyFilter = useCallback(
    debounce((q: string) => applyFilter(q), delay),
    [],
  );

  return delayedApplyFilter;
};

export default useDebounce;
